import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "../mychart/MyChartContainer";

/**
 * Container component for the Admini Info page.
 * 
 */
class AdminInfo extends React.Component {

    componentDidMount() {
        logUI("MBHWeb.UI.AdminInfo.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { serverData } = this.props;
        const heading = (
            <div className="row">
                <div className="col-12 col-md-6">
                    <h1 className="page-heading">Administrative Information</h1>
                </div>
                <div className="col-12 col-md-6 text-md-right">
                    <div className="mychart-btn-container--full-width-desktop bswh-mychart-overlay">
                        <Link className="btn btn-primary" to={{ pathname: "/demographics" }}>PATIENT INFORMATION</Link>
                    </div>
                </div>
            </div>
        );
        return <MyChartContainer mode="patinfo" title="Administrative Information" heading={heading} byroute="false" serverData={serverData} />;
    }

}


const mapStateToProps = (state) => {
    return {

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminInfo);